var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Autocomplete, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, IconButton, TextField, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { Controller, useForm } from 'react-hook-form';
import { RoleCategories } from '../../../../../application/common/constants/role-categories';
import { useGetAllCompaniesQuery } from '../../../../../application/features/companies/company-api';
import { useCreateSpecialityMutation } from '../../../../../application/features/specialities/speciality-api';
import { useAppSelector } from '../../../../../application/store/useStore';
import useTranslate from '../../../../../localization/helpers';
var AddSpecialty = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var _b = useTranslate(), translate = _b.translate, tWithField = _b.tWithField, tWithFunction = _b.tWithFunction;
    var currentCompany = useAppSelector(function (state) { return state.common; }).currentCompany;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _c = __read(useCreateSpecialityMutation(), 2), createSpeciality = _c[0], _d = _c[1], isLoading = _d.isLoading, isSuccess = _d.isSuccess;
    var _e = __read(useState([]), 2), currentCompanies = _e[0], setCurrentCompanies = _e[1];
    var _f = useGetAllCompaniesQuery({
        filterByCompany: true
    }), _g = _f.data, allCompanies = _g === void 0 ? [] : _g, isCompaniesLoading = _f.isLoading, isCompaniesFetching = _f.isFetching;
    var _h = useForm({
        defaultValues: {
            name: '',
            companies: []
        }
    }), control = _h.control, handleSubmit = _h.handleSubmit, reset = _h.reset, setValue = _h.setValue, errors = _h.formState.errors;
    useEffect(function () {
        if (currentCompany && currentUser.roleCategory !== RoleCategories.SuperAdmin) {
            setValue('companies', [currentCompany.id], { shouldValidate: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentCompany, currentUser]);
    useEffect(function () {
        if (currentUser.roleCategory === RoleCategories.SuperAdmin)
            setCurrentCompanies(allCompanies);
    }, [allCompanies, currentUser]);
    useEffect(function () {
        if (isSuccess) {
            enqueueSnackbar(tWithField('toolTips.addSuccess', 'common.speciality'), {
                autoHideDuration: 3000,
                variant: 'success',
                anchorOrigin: { horizontal: 'right', vertical: 'top' }
            });
            closeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);
    var closeDialog = function () {
        reset();
        onClose();
    };
    var onSubmit = function (speciality) {
        if (currentCompany && currentUser.roleCategory !== RoleCategories.SuperAdmin) {
            speciality.companies = [currentCompany.id];
        }
        createSpeciality(speciality);
    };
    return (_jsxs(Dialog, { open: open, fullWidth: true, maxWidth: 'sm', onClose: onClose, children: [_jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }, children: [_jsx(Typography, { variant: 'h6', children: tWithFunction('actions.addFunction', 'common.speciality') }), ' ', _jsx(IconButton, { size: 'Xs', style: { marginLeft: 'auto' }, onClick: onClose, children: _jsx(X, { color: '#637381' }) })] }), _jsxs(DialogContent, { children: [_jsx(Controller, { name: 'name', control: control, rules: {
                            required: {
                                value: true,
                                message: tWithField('validations.fieldIsRequired', 'settings.technicianSpecialties.specialtyName')
                            },
                            maxLength: {
                                value: 128,
                                message: translate('validations.maximumCharactersAllowed', { count: 128 })
                            }
                        }, render: function (_a) {
                            var _b;
                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                            return (_jsxs(FormControl, { fullWidth: true, sx: { my: '10px' }, children: [_jsx(TextField, { disabled: isLoading, fullWidth: true, label: translate('settings.technicianSpecialties.specialtyName'), value: value, onChange: onChange, error: !!errors.name }), _jsx(FormHelperText, { error: true, children: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message })] }));
                        } }), (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin && (_jsx(Controller, { name: 'companies', control: control, rules: {
                            required: {
                                value: true,
                                message: tWithField('validations.fieldIsRequired', 'common.company')
                            }
                        }, render: function (_a) {
                            var _b;
                            var _c = _a.field, onChange = _c.onChange, value = _c.value;
                            return (_jsxs(FormControl, { fullWidth: true, children: [_jsx(Autocomplete, { noOptionsText: translate('common.noOptions'), multiple: true, disabled: isLoading || isCompaniesLoading, loading: isCompaniesFetching, options: currentCompanies.filter(function (company) { return company.isActive === true; }), value: currentCompanies.filter(function (company) { return value.includes(company.id); }), isOptionEqualToValue: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { return option.name; }, disableCloseOnSelect: true, slotProps: { chip: { size: 'small', variant: 'soft' } }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { variant: 'outlined', fullWidth: true, label: translate('common.companies'), error: !!errors.companies }))); }, onChange: function (_, value) {
                                            onChange(value.map(function (val) { return val.id; }));
                                        }, renderOption: function (props, option, _a) {
                                            var selected = _a.selected;
                                            return (_createElement("li", __assign({}, props, { key: option.id }),
                                                _jsx(Checkbox, { style: { marginRight: 8 }, checked: selected }),
                                                option.name));
                                        }, sx: {
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '8px',
                                                '&.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
                                                    padding: '3.5px 4px 3.5px 8px'
                                                }
                                            }
                                        } }), _jsx(FormHelperText, { error: true, children: (_b = errors.companies) === null || _b === void 0 ? void 0 : _b.message })] }));
                        } }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { variant: 'outlined', color: 'inherit', onClick: closeDialog, children: translate('actions.cancel') }), _jsx(Button, { variant: 'contained', color: 'inherit', onClick: handleSubmit(onSubmit), disabled: isLoading, children: translate('actions.addNow') })] })] }));
};
export default AddSpecialty;
